export default __webpack_public_path__ + "static/media/electronicsButton.c164a4d7.jpeg";